import httpClient, {
  getResponseData,
  getErrorMessage,
} from 'lib/httpClient';
import { createQueryString } from 'lib/utils';

export const getProducts = async ({ query, headers } = {}) => {
  try {
    const response = await httpClient.get('/products', {
      params: query,
      headers,
    });

    return { response: getResponseData(response) };
  } catch (err) {
    return { error: getErrorMessage(err) };
  }
};

export const getProductById = async (productId) => {
  try {
    const response = await httpClient.get(`/products/${productId}`);

    return { response: getResponseData(response) };
  } catch (err) {
    return { error: getErrorMessage(err) };
  }
};

export const getProductBySlug = async (
  slug,
  opts = {},
  headers = {},
) => {
  try {
    const response = await httpClient.get(`/products/${slug}/slug`, {
      headers,
    });

    return { response: getResponseData(response) };
  } catch (err) {
    if (opts.rawError) {
      throw err;
    }
    return { error: getErrorMessage(err) };
  }
};

export const getLastOrderedProductsUrl = (userId, params) => {
  const formattedQueryString = createQueryString({
    per_page: params?.perPage,
    page: params?.page,
  });

  return `/users/${userId}/ordered_lines?${formattedQueryString}`;
};

export const getLastOrderedProducts = async (userId, params) => {
  const response = await httpClient.get(
    getLastOrderedProductsUrl(userId, params),
  );

  return response.data;
};
